<template>
    <div class="navigation">
        <template>
            <!-- TOPBAR -->
            <v-toolbar height="120" :class="isThemeAja ? 'aja-bg-card' : ''">
                <v-toolbar-title class="d-flex">
                    <!-- [AJA and !Auth] Return Home classic arrow -->
                    <router-link v-if="isThemeAja && $acl.check('isNotAuth')" :to="{ name: 'home' }" class="router-link text-no-underline" active-class="primary--text">
                        <v-btn icon class="mt-10"><v-icon large class="aja-icon-primary">keyboard_double_arrow_left</v-icon></v-btn>
                    </router-link>

                    <!-- Home Icon -->
                    <router-link :to="isThemeAja ? { name: 'aja-home' } : { name: 'home' }" class="router-link text-no-underline" active-class="primary--text">
                        <v-btn icon class="mt-10"><v-icon large class="aja-icon-primary">home</v-icon></v-btn>
                    </router-link>

                    <!-- Oncogitiel Logo -->
                    <router-link :to="{ name: 'Oncogitiel' }" class="hidden-sm-and-down router-link text-no-underline px-4" active-class="primary--text">
                        <v-img v-if="$vuetify.theme.dark" max-width="170" class="mt-4 ml-2" :src="require('@/assets/images/logo_oncogitiel_white_new.png')"></v-img>
                        <v-img v-if="!$vuetify.theme.dark" max-width="170" class="mt-4 ml-2" :src="require('@/assets/images/logo_oncogitiel_grey.png')"></v-img>
                    </router-link>
                </v-toolbar-title>
                <v-spacer />

                <v-toolbar-items class="hidden-sm-and-down text-uppercase text-center align-center">
                    <!-- [AJA or !Auth] Home AJA  -->
                    <router-link style="margin-left: -120px;" v-if="isThemeAja || $acl.check('isNotAuth')" :to="{ name: 'aja-home' }">
                        <v-img v-if="$vuetify.theme.dark" class=" mt-4" :src="require('@/assets/images/Logo_AJA.png')" width="200" alt="OnCOGITE" contain></v-img>
                        <v-img v-if="!$vuetify.theme.dark" class=" mt-4" :src="require('@/assets/images/Logo_AJA_white.png')" width="200" alt="OnCOGITE" contain></v-img>
                    </router-link>
                    
                    <!-- [ADH PRO] Ateliers PRO (visible aussi en thème AJA pour les pros AJA) -->
                    <router-link v-if="$acl.check('isProPremium')" :to="{ name: 'WorkshopsPro' }"
                        class="router-link text-no-underline px-4" active-class="primary--text">
                        <v-icon color="primary" size="50px" class="mt-3 mb-2">cases</v-icon>
                        <div>Ateliers PRO</div>
                    </router-link>

                    <!-- [!AJA] Workshops MAP  -->
                    <router-link v-if="!isThemeAja" :to="{ name: 'WorkshopsMap' }" class="router-link text-no-underline px-4" active-class="primary--text">
                        <v-icon color="primary" size="50px" class="mt-3 mb-2">explore</v-icon>
                        <div>Séances présentielles</div>
                    </router-link>

                    <!-- [!AJA] ONCO'MMENCE Sessions -->
                    <router-link v-if="!isThemeAja && showOncommenceMenu" :to="{ name: 'WorkshopsOncommence' }"
                        class="router-link text-no-underline px-4" active-class="primary--text">
                        <v-icon color="primary" size="50px" class="mt-3 mb-2">waving_hand</v-icon>
                        <div>Sessions ONCO'MMENCE</div>
                    </router-link>

                    <!-- [!AJA] Workshops List  -->
                    <router-link v-if="!isThemeAja" :to="{ name: 'ListWorkshops' }"
                        class="router-link text-no-underline px-4" active-class="primary--text">
                        <v-icon color="primary" size="70px">$onsite_workshop</v-icon>
                        <v-icon color="primary" size="70px">$remote_workshop</v-icon>
                        <div>Les Ateliers</div>
                    </router-link>

                    <!-- [AJA] AJA Workshops List  -->
                    <router-link v-if="isThemeAja" :to="{ name: 'AJAWorkshops' }"
                        class="router-link text-no-underline px-4" active-class="primary--text">
                        <v-icon color="#4E983C" size="70px">psychology</v-icon>
                        <div style="color: #4E983C">Les Ateliers de remédiation</div>
                    </router-link>
                </v-toolbar-items>
                <v-spacer />

                <!-- [Auth and !AJA] Surveys Alert -->
                <QrAlert v-if="$acl.check('isAuth') && $acl.check('isUserPremium') && $acl.not.check('isProPremium') && !isThemeAja" />

                <!-- [Auth and isPro] Renewal Alert -->
                <ProRenewalAlert v-if="$acl.check('isAuth') && $acl.check('isPro')" />

                <!-- Connexion/Register/Profile -->
                <v-toolbar-items class="py-5 hidden-sm-and-down secondary--text">
                    <ProfileToolbar />
                </v-toolbar-items>

                <!-- Menu Burger -->
                <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-app-bar-nav-icon>

                <!-- Dark/Light Theme -->
                <v-btn v-if="!isThemeAja" text icon @click.stop="changeTheme">
                    <v-icon v-if="$vuetify.theme.dark">wb_sunny</v-icon>
                    <v-icon v-else>brightness_3</v-icon>
                </v-btn>
            </v-toolbar>

            <!-- LEFTBAR -->
            <v-navigation-drawer v-model="drawer" temporary absolute id="drawer" width="315" color="secondary">
               <!-- Menu Burger -->
                <v-toolbar height="120">
                    <v-toolbar-title class="mx-auto">
                        <v-img v-if="$vuetify.theme.dark" alt="" :src="require('@/assets/images/logo_menu_blanc.png')"></v-img>
                        <v-img v-else alt="" :src="require('@/assets/images/logo_menu_noir.png')"></v-img>
                    </v-toolbar-title>
                </v-toolbar>
                <v-divider></v-divider>

                <v-list dark class="py-0">
                    <v-list-item>
                        <!-- Connexion/Register/Profile -->
                        <v-list-item-title class="py-5">
                            <ProfileToolbar />
                        </v-list-item-title>
                    </v-list-item>

                    <!-- [Auth and isPro] Mobile Renewal Alert -->
                    <v-list-item v-if="$acl.check('isAuth') && $acl.check('isPro')" :to="{ name: 'payment-resubscription' }" class="my-2">
                        <v-list-item-action>
                            <v-icon color="warning" size="35px" class="mr-4">card_membership</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>
                            <span v-if="showRenewalAlert">Renouveler mon adhésion</span>
                        </v-list-item-title>
                    </v-list-item>

                    <!-- AJA Home -->
                    <v-list-item @click="$router.push({ name: 'aja-home' })" :class="{ 'primary': $route.name == 'aja-home' }">
                        <v-list-item-action>
                            <v-img max-width="50" :src="require('@/assets/images/Logo_AJA.png')"></v-img>
                        </v-list-item-action>
                        <v-list-item-title>
                            <div><span style="color: #4E983C">On</span>cogit<span style="color: #4E983C">AJA</span></div>
                        </v-list-item-title>
                    </v-list-item>

                    <!-- Oncogitiel -->
                    <v-list-item @click="$router.push({ name: 'Oncogitiel' })" :class="{ 'primary': $route.name == 'Oncogitiel' }">
                        <v-list-item-action>
                            <v-img v-if="$vuetify.theme.dark" max-width="50" :src="require('@/assets/images/logo_oncogitiel_white_new.png')"></v-img>
                            <v-img v-else max-width="50" :src="require('@/assets/images/logo_oncogitiel_grey.png')"></v-img>
                        </v-list-item-action>
                        <v-list-item-title>
                            <div><span style="color: orange">On</span>cogit<span style="color: orange">iel</span></div>
                        </v-list-item-title>
                    </v-list-item>

                    <!-- Ateliers PRO (ADH PRO, y compris pros AJA) -->
                    <v-list-item v-if="$acl.check('isProPremium')"
                        @click="$router.push({ name: 'WorkshopsPro' })"
                        :class="{ 'primary': $route.name == 'WorkshopsPro' }">
                        <v-list-item-action>
                            <v-icon color="white" size="35px" class="mr-4">cases</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Ateliers PRO</v-list-item-title>
                    </v-list-item>



                    <!-- Workshops MAP -->
                    <v-list-item @click="$router.push({ name: 'WorkshopsMap' })"
                        :class="{ 'primary': $route.name == 'WorkshopsMap' }">
                        <v-list-item-action>
                            <v-icon color="white" size="35px" class="mr-4">explore</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Séances présentielles</v-list-item-title>
                    </v-list-item>
                    
                    <!-- Workhops -->
                    <v-list-item @click="$router.push({ name: 'ListWorkshops' })" :class="{ 'primary': $route.name == 'ListWorkshops' }">
                        <v-list-item-action>
                            <v-icon color="white" width="50px" height="50px">$remote_workshop</v-icon>
                            <v-icon color="white" width="50px" height="50px">$onsite_workshop</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Les Ateliers</v-list-item-title>
                    </v-list-item>

                    <!-- AJA Workhops -->
                    <v-list-item @click="$router.push({ name: 'AJAWorkshops' })" :class="{ 'primary': $route.name == 'AJAWorkshops' }">
                        <v-list-item-action>
                            <v-icon color="#4E983C" width="50px" height="50px">psychology</v-icon>
                        </v-list-item-action>
                        <v-list-item-title style="color: #4E983C">Les Ateliers de remédiation</v-list-item-title>
                    </v-list-item>
                    
                    <!-- [LOGGED] Meetings -->
                    <v-list-item @click="$router.push({ name: 'Meetings' })" v-if="$acl.check('isUser')" :class="{ 'primary': $route.name == 'Meetings' }">
                        <v-list-item-action>
                            <v-icon x-large color="white">alarm</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Mes séances</v-list-item-title>
                    </v-list-item>

                    <!-- [ADH PRO] Mes séances PRO -->
                    <v-list-item v-if="$acl.check('isProPremium')"
                        @click="$router.push({ name: 'MeetingsPro' })"
                        :class="{ 'primary': $route.name == 'MeetingsPro' }">
                        <v-list-item-action>
                            <v-icon x-large color="white">alarm</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Mes séances PRO</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>

            <!-- UP BUTTON -->
            <v-scale-transition origin="center center">
                <v-btn fixed dark fab bottom right class="aja-btn-primary" v-if="scrolled" @click="$vuetify.goTo('#app')">
                    <v-icon x-large>keyboard_arrow_up</v-icon>
                </v-btn>
            </v-scale-transition>

            <!-- PREV BUTTON -->
            <v-btn v-if="$route.name != 'home'" fixed dark fab bottom left class="aja-btn-primary" @click="goBack">
                <v-icon x-large>keyboard_arrow_left</v-icon>
            </v-btn>
        </template>
    </div>
</template>
<script>
import ProfileToolbar from '@/components/ProfileToolbar'
import QrAlert from '@/components/QrAlert'
import ProRenewalAlert from '@/components/ProRenewalAlert'
import { mapGetters } from 'vuex'
export default {
    components: {
        ProfileToolbar,
        QrAlert,
        ProRenewalAlert,
    },
    data() {
        return {
            drawer: false,
            ready: false,
            scrolled: false,
            from: null,
        }
    },
    mounted() {
        this.ready = true
        window.onscroll = e => this.onScroll(e)
        if (localStorage.getItem('theme.dark') !== null)
            this.$vuetify.theme.dark = (localStorage.getItem('theme.dark') == 'true')

    },
    computed: {
        ...mapGetters(['isThemeAja']),
        showOncommenceMenu() {
            if (!this.$acl.check('isAuth'))
                return true;

            const profile = this.$store.getters.getProfile;
            if (!profile) 
                return true;
            
            if (profile.show_oncommence_menu)
                return true;
            
            return false;
        },
        showRenewalAlert() {
            const profile = this.$store.getters.getProfile;
            if (!profile || !profile.premium_dates) 
                return false;
                
            const endDate = this.$moment(profile.premium_dates.end).format('YYYY-MM-DD');
            const showAlertDate = this.$moment(endDate).subtract(15, 'days').format('YYYY-MM-DD');
            const today = this.$moment().format('YYYY-MM-DD');
            
            return this.$moment(today).isBetween(showAlertDate, endDate);
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.from = from
        })
    },
    methods: {
        onScroll(e) {
            if (window.pageYOffset > 70) {
                this.scrolled = true
            } else {
                this.scrolled = false
            }
        },
        goBack() {
            let from = this.$store.getters.getFromRoute()
            if (['EditWorkshop', 'CreateWorkshop'].indexOf(from.name) >= 0) {
                this.$router.go(-2)
            } else {
                this.$router.go(-1)
            }
        },
        changeTheme() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark
            localStorage.setItem('theme.dark', this.$vuetify.theme.dark)
        }
    }
}
</script>
